import 'magnific-popup'

$(function() {

  $('.js-imageModal').magnificPopup({
    type: 'image',
    mainClass: 'p-whiteBackModal',
    closeBtnInside: false,
    showCloseBtn: true,
    fixedContentPos: true,
    callbacks: {
      open: function(){
        const scrollpos = $(window).scrollTop()
        $('body').css('overflow','hidden');
        $('body').css('height','100%');
        $('html').css('height','100%');
        $('.l-container').css({
          position: 'fixed',
          height: '100%',
          overflow: 'hidden',
          width: '100%',
          top: -scrollpos,
        })
        .attr('data-top', scrollpos)
      },
      close: function(){
        $('body').css('overflow','auto');
        $('body').css('height','auto');
        $('html').css('height','auto');
        const returnpos = parseInt($('.l-container').attr('data-top'))
        $('.l-container').removeAttr('style')
        $(window).scrollTop(returnpos)
      }
    }
  });

});
